<template>
  <!--
      传路由routerName=""跳特定页面
      公用头部引入
      <app-header title="标题" routerName=""></app-header>
  -->
  <div class="header">
    <van-nav-bar
      class="nav-bar"
      :title="title"
      fixed
      left-arrow
      @click-left="onClickLeft"
    />
  </div>
</template>

<style lang="less" scoped>
/deep/ .van-nav-bar--fixed {
  z-index: 199;
}
</style>
<script>
export default {
  name: "appheader",
  props: {
    title: {
      type: String,
      default: "",
    },
    routerName: {
      //传路由跳特定页面
      type: String,
      default: "",
    },
  },
  data() {
    return {
      text_title: "",
    };
  },
  created() {},
  methods: {
    //返回上一页
    onClickLeft() {
      //   window.history.go(-1);
      if (this.routerName) {
        this.$router.replace({
          name: this.routerName,
        });
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/public/header.vue